import { render } from "./CommandBar.vue?vue&type=template&id=6f202d16"
import script from "./CommandBar.vue?vue&type=script&lang=js"
export * from "./CommandBar.vue?vue&type=script&lang=js"

import "./CommandBar.vue?vue&type=style&index=0&id=6f202d16&lang=css"
script.render = render

export default script